import { NavLink } from '@festina-life/ui/actions'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import { generalRoutes } from '../../../routing/generalRoutes'
import { OverviewItem } from '../../overview/OverviewItem'
import { OverviewSection } from '../../overview/OverviewSection'
import { OverviewTitle } from '../../overview/OverviewTitle'
import { withCommitment } from '../../wrappers/withCommitment'
import { PoliciesSectionEmptyState } from './PoliciesSectionEmptyState'

const PoliciesSectionInternal = () => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data: commitmentVersion } = useHook(
    'fetchers.life.useFetchCommitmentVersionLatest',
  )({ ownerId, tenantId })
  const renderPolicy = useHook('pages.commitment.useLazyRenderPolicy')()
  const policies = commitmentVersion?.policyVersions ?? []

  const emptyReason =
    commitmentVersion?.commitmentStatus === 'terminated'
      ? translate('pages.commitment.tabs.policyEmptyReason', {
          status: translateEnum(
            'life.enum.CommitmentStatus',
            commitmentVersion.commitmentStatus,
          ),
        })
      : undefined

  return (
    <OverviewSection>
      <OverviewTitle>{translate('policiesSection.title')}</OverviewTitle>
      {policies.length === 0 && (
        <PoliciesSectionEmptyState emptyReason={emptyReason} />
      )}
      {policies.map((policy) => (
        <OverviewItem iconName="DocumentText" key={policy?.policyKey}>
          <NavLink
            className="block"
            to={generalRoutes.commitment.workbenchPoliciesTab({
              tenantId,
              ownerId,
            })}
          >
            {renderPolicy(policy?.policyKey)}
          </NavLink>
        </OverviewItem>
      ))}
    </OverviewSection>
  )
}

export const PoliciesSection = withCommitment(PoliciesSectionInternal)
